module.exports = __webpack_public_path__ + "img/geofisica_9-16_540.8f35424d.webp";